// pdfGenerator.js

import axios from 'axios';
import { PDFDocument } from 'pdf-lib';

export const generatePdf = async (formData, signatureData, previousAddresses, previousNames) => {
  const axiosDomain = process.env.REACT_APP_AXIOS_DOMAIN;

  try {
    // Fetch the PDF templates
    const [pdfBytes, coaBytes, appendixBytes] = await Promise.all([
      axios.get(`${axiosDomain}/api/pdf/template`, { responseType: 'arraybuffer' }).then(res => res.data),
      axios.get(`${axiosDomain}/api/pdf/coa`, { responseType: 'arraybuffer' }).then(res => res.data),
      axios.get(`${axiosDomain}/api/pdf/appendix`, { responseType: 'arraybuffer' }).then(res => res.data),
    ]);

    // Proceed with your existing PDF generation logic
    const mergedDoc = await PDFDocument.create();
    let pdfDocs = [];

    // Generate LOA PDFs
    pdfDocs.push({
      lender: formData.lender,
      data: await PDFDocument.load(pdfBytes),
    });

    const pdfDoc = pdfDocs[0].data;
    const form = pdfDoc.getForm();

    // Fill in the form fields
    form.getTextField('Salutation').setText(`${formData.title} ${formData.first_name} ${formData.last_name}`);
    form.getTextField('AddLine1').setText(formData.current_address_line_1);
    form.getTextField('AddLine2').setText(formData.current_address_line_2);
    form.getTextField('AddLine3').setText(formData.current_address_line_3);
    form.getTextField('AddLine4').setText(formData.current_address_line_4);
    form.getTextField('PostCode').setText(formData.current_post_code);
    form.getTextField('Personalized').setText(`${formData.title} ${formData.first_name} ${formData.last_name}`);
    form.getTextField('ThisDate').setText(new Date().toLocaleDateString('en-GB'));
    form.getTextField('YourRef').setText(formData.signup_caseid);
    form.getTextField('PPIName').setText(`${formData.first_name} ${formData.last_name}`);
    form.getTextField('PPICA').setText(formData.signup_caseid);
    form.getTextField('Salutation_1').setText(`${formData.title} ${formData.first_name} ${formData.last_name}`);
    form.getTextField('AddLine1_1').setText(formData.current_address_line_1);
    form.getTextField('AddLine2_1').setText(formData.current_address_line_2);
    form.getTextField('AddLine3_1').setText(formData.current_address_line_3);
    form.getTextField('AddLine4_1').setText(formData.current_address_line_4);
    form.getTextField('PostCode_1').setText(formData.current_post_code);
    form.getTextField('YourRef_1').setText(formData.signup_caseid);
    form.getTextField('ThisDate_1').setText(new Date().toLocaleDateString('en-GB'));
    form.getTextField('FullName').setText(`${formData.first_name} ${formData.last_name}`);

    // Set radio buttons for questions
    form.getRadioGroup('Ques1').select(formData.question1 === 'yes' ? 'Q1Yes' : 'Q1No');
    form.getRadioGroup('Ques2').select(formData.question2 === 'yes' ? 'Q2Yes' : 'Q2No');
    form.getRadioGroup('Ques3').select(formData.question3 === 'yes' ? 'Q3Yes' : 'Q3No');
    form.getTextField('QDate').setText(new Date().toLocaleDateString('en-GB'));

    form.getTextField('LenderName1').setText(formData.selectedLender);
    form.getTextField('LenderName2').setText(formData.selectedLender);

    form.getTextField('DealerName1').setText(formData.car_dealership_name);
    form.getTextField('DealerName2').setText(formData.car_dealership_name);

    form.getTextField('AccountHolder1').setText(`${formData.first_name} ${formData.last_name}`);
    form.getTextField('AccountHolder2').setText(`${formData.first_name} ${formData.last_name}`);

    form.getTextField('DOB1').setText(formData.date_of_birth ? new Date(formData.date_of_birth).toLocaleDateString('en-GB') : '');
    form.getTextField('DOB2').setText(formData.date_of_birth ? new Date(formData.date_of_birth).toLocaleDateString('en-GB') : '');

    form.getTextField('AddLine1_2_1').setText(formData.current_address_line_1);
    form.getTextField('AddLine1_2_2').setText(formData.current_address_line_1);
    form.getTextField('AddLine2_2_1').setText(formData.current_address_line_2);
    form.getTextField('AddLine2_2_2').setText(formData.current_address_line_2);
    form.getTextField('AddLine3_2_1').setText(formData.current_address_line_3);
    form.getTextField('AddLine3_2_2').setText(formData.current_address_line_3);
    form.getTextField('AddLine4_2_1').setText(formData.current_address_line_4);
    form.getTextField('AddLine4_2_2').setText(formData.current_address_line_4);
    form.getTextField('PostCode_2_1_1').setText(formData.current_post_code);
    form.getTextField('PostCode_2_2').setText(formData.current_post_code);

    form.getTextField('LOADate1').setText(new Date().toLocaleDateString('en-GB'));
    form.getTextField('LOADate2').setText(new Date().toLocaleDateString('en-GB'));

    form.getTextField('OurRef_1').setText(formData.signup_caseid);
    form.getTextField('OurRef_2').setText(formData.signup_caseid);

    if (previousAddresses.length > 0) {
      const prevAdd = previousAddresses[0];
      form.getTextField('PrevAddLine1_1').setText(prevAdd.previous_address_line_1);
      form.getTextField('PrevAddLine1_2').setText(prevAdd.previous_address_line_1);
      form.getTextField('PrevAddLine2_1').setText(prevAdd.previous_address_line_2);
      form.getTextField('PrevAddLine2_2').setText(prevAdd.previous_address_line_2);
      form.getTextField('PrevAddLine3_1').setText(prevAdd.previous_address_line_3);
      form.getTextField('PrevAddLine3_2').setText(prevAdd.previous_address_line_3);
      form.getTextField('PrevAddLine4_1').setText(prevAdd.previous_address_line_4);
      form.getTextField('PrevAddLine4_2').setText(prevAdd.previous_address_line_4);
      form.getTextField('PrevPostCode_1').setText(prevAdd.previous_post_code);
      form.getTextField('PrevPostCode_2').setText(prevAdd.previous_post_code);
    }

    form.getTextField('ThisDate_2').setText(new Date().toLocaleDateString('en-GB'));
    form.getTextField('Party').setText(
      `${formData.first_name} ${formData.last_name}, of ${formData.current_address_line_1}, ${formData.current_address_line_2}, ${formData.current_address_line_3}, ${formData.current_address_line_4}, ${formData.current_post_code}`
    );
    form.getTextField('Defendant').setText(formData.selectedLender);
    form.getTextField('YourName').setText(formData.selectedLender);
    form.getTextField('DBADate').setText(new Date().toLocaleDateString('en-GB'));
    form.getTextField('DBADate2').setText(new Date().toLocaleDateString('en-GB'));
    form.getTextField('CaseReference_1').setText(formData.signup_caseid);
    form.getTextField('CaseReference').setText(formData.signup_caseid);

    // Add signature images
    if (signatureData) {
      const pngImage = await pdfDoc.embedPng(signatureData);
      const pages = pdfDoc.getPages();

      let sigPage = pages[3];
      sigPage.drawImage(pngImage, {
        x: 90,
        y: 145,
        width: 100,
        height: 50,
      });

      sigPage = pages[4];
      sigPage.drawImage(pngImage, {
        x: 90,
        y: 290,
        width: 100,
        height: 50,
      });

      sigPage = pages[5];
      sigPage.drawImage(pngImage, {
        x: 90,
        y: 290,
        width: 100,
        height: 50,
      });

      sigPage = pages[10];
      sigPage.drawImage(pngImage, {
        x: 370,
        y: 355,
        width: 100,
        height: 50,
      });
    }

    const pdfBytesUpdated = await pdfDoc.save();
    const donorPDF = await PDFDocument.load(pdfBytesUpdated);
    const copiedPages = await mergedDoc.copyPages(donorPDF, donorPDF.getPageIndices());
    copiedPages.forEach((page) => mergedDoc.addPage(page));
    pdfDocs[0].data = pdfBytesUpdated;

    // Generate COA PDFs
    let COADocs = [];

    if (coaBytes) {
      COADocs.push({
        lender: formData.selectedLender,
        data: await PDFDocument.load(coaBytes),
      });

      const COADoc = COADocs[0].data;
      const COAform = COADoc.getForm();
      COAform.getTextField('datecreated').setText(new Date().toLocaleDateString());
      COAform.getTextField('clientfullname').setText(`${formData.title} ${formData.first_name} ${formData.last_name}`);
      COAform.getTextField('docsigneddate').setText(new Date().toLocaleDateString());
      COAform.getTextField('refnumber').setText(formData.signup_caseid);
      COAform.getTextField('ipaddress').setText(formData.ip);

      if (signatureData) {
        const pngImage = await COADoc.embedPng(signatureData);
        const pages = COADoc.getPages();
        const firstPage = pages[0];
        firstPage.drawImage(pngImage, {
          x: 220,
          y: 450,
          width: 100,
          height: 50,
        });
      }

      const coaBytesUpdated = await COADoc.save();
      const COAPDF = await PDFDocument.load(coaBytesUpdated);
      const copiedPagesCOA = await mergedDoc.copyPages(COAPDF, COAPDF.getPageIndices());
      copiedPagesCOA.forEach((page) => mergedDoc.addPage(page));
      COADocs[0].data = coaBytesUpdated;
    }

    // Generate Appendix PDFs if necessary
    let appendixDocs = [];

    if (appendixBytes && (previousNames.length > 1 || previousAddresses.length > 1)) {
      appendixDocs.push({
        data: await PDFDocument.load(appendixBytes),
      });

      const appendixDoc = appendixDocs[0].data;
      const appendixForm = appendixDoc.getForm();

      previousNames.forEach((name, index) => {
        if (index + 1 <= 3) {
          appendixForm.getTextField(`PrevName${index + 1}`).setText(name);
        }
      });

      previousAddresses.forEach((address, index) => {
        if (index + 1 <= 5) {
          appendixForm.getTextField(`PrevAdd${index + 1}Line1`).setText(address.previous_address_line_1);
          appendixForm.getTextField(`PrevAdd${index + 1}Line2`).setText(address.previous_address_line_2);
          appendixForm.getTextField(`PrevAdd${index + 1}Line3`).setText(address.previous_address_line_3);
          appendixForm.getTextField(`PrevAdd${index + 1}Line4`).setText(address.previous_address_line_4);
          appendixForm.getTextField(`PrevAdd${index + 1}Line5`).setText(address.previous_post_code);
        }
      });

      if (signatureData) {
        const pngImage = await appendixDoc.embedPng(signatureData);
        const pages = appendixDoc.getPages();
        const firstPage = pages[0];
        firstPage.drawImage(pngImage, {
          x: 90,
          y: 90,
          width: 100,
          height: 50,
        });
      }

      appendixForm.getTextField('LOADate').setText(new Date().toLocaleDateString());
      const appendixBytesUpdated = await appendixDoc.save();
      const appendixPDF = await PDFDocument.load(appendixBytesUpdated);
      const copiedPagesAppendix = await mergedDoc.copyPages(appendixPDF, appendixPDF.getPageIndices());
      copiedPagesAppendix.forEach((page) => mergedDoc.addPage(page));
      appendixDocs[0].data = appendixBytesUpdated;
    }

    // Merge all PDFs
    const mergedPdfBytes = await mergedDoc.save();

    // Return the generated PDFs
    return {
      loaPDFs: pdfDocs.map((pdf) => ({
        lender: pdf.lender,
        data: pdf.data,
      })),
      coaPDFs: COADocs.map((pdf) => ({
        lender: pdf.lender,
        data: pdf.data,
      })),
      appendixPDFs: appendixDocs.length > 0
        ? appendixDocs.map((doc) => ({
            data: doc.data,
          }))
        : [],
    };
  } catch (error) {
    console.error('Error generating PDFs:', error);
    throw error;
  }
};
